import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function FrenchIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    height: "600",
    viewBox: "0 0 900 600",
    width: "900"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "#ED2939",
    height: "600",
    width: "900"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: "600",
    width: "600"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#002395",
    height: "600",
    width: "300"
  }));
}